// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ng-2";
export var chatLink = "_ng-0";
export var chatText = "_ng-1";